import { Form, TextAreaInput } from '@thinknet-gmbh/platform-common-ui';

import { TextAreaContainer } from './employee-interview-articles-form-list.styles';

interface IProps {
  interviewType: any;
  formListName: string | (string | number)[];
  t: Function;
}

const InterviewArticlesFormList = ({ interviewType, formListName, t }: IProps) => (
  <TextAreaContainer>
    <Form.List name={formListName} initialValue={interviewType}>
      {fields => (
        <div>
          {fields.map(field => {
            const type = interviewType[field.name];

            return (
              <Form.Item name={[field.name, 'description']} key={field.key} label={type?.headline}>
                <TextAreaInput
                  showCount
                  maxLength={5000}
                  placeholder={t('employee:labels.writeDetails')}
                />
              </Form.Item>
            );
          })}
        </div>
      )}
    </Form.List>
  </TextAreaContainer>
);

export default InterviewArticlesFormList;
